var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIcNext(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "fluent:next-32-filled"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M19.5015 3.75001C19.5015 3.5511 19.5805 3.36033 19.7212 3.21968C19.8618 3.07903 20.0526 3.00001 20.2515 3.00001C20.4504 3.00001 20.6412 3.07903 20.7818 3.21968C20.9225 3.36033 21.0015 3.5511 21.0015 3.75001V20.25C21.0015 20.4489 20.9225 20.6397 20.7818 20.7803C20.6412 20.921 20.4504 21 20.2515 21C20.0526 21 19.8618 20.921 19.7212 20.7803C19.5805 20.6397 19.5015 20.4489 19.5015 20.25V3.75001ZM2.99927 4.87801C2.99927 3.37651 4.67627 2.48401 5.92202 3.32326L16.4243 10.3973C16.678 10.5683 16.886 10.7989 17.0302 11.0689C17.1743 11.3389 17.2502 11.64 17.2511 11.9461C17.2521 12.2521 17.1781 12.5537 17.0357 12.8246C16.8933 13.0955 16.6867 13.3273 16.434 13.5L5.93177 20.67C4.68677 21.519 2.99927 20.628 2.99927 19.1213V4.87801Z",
    fill: "white"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcNext);
export default __webpack_public_path__ + "static/media/ic_next.8de77be94521204e362747116b5a7002.svg";
export { ForwardRef as ReactComponent };